<template>

<div class="menus-admin">
    <!-- <menus
        :menus="menus"
        :menuItems="menuItems"
        :filters="filters"
        :showLinkType="true"
        :doCancelMenuItem="doCancelMenuItem"
        :editingMenuItemMessage="editingMenuItemMessage"
        :loading="loading"
        :saving="saving"
        @fetchMenu="fetchMenu"
        @saveMenu="saveMenu"
        @deleteMenu="deleteMenu"
        @saveMenuItem="saveMenuItem">
    </menus> -->
    <menus
        :filters="filters"
        :showLinkType="true">
    </menus>
</div>

</template>

<script>
export default {
    name: 'menus-admin',
    props: [ 'page' ],
    data() {
        return {
            loading: true,
            saving: false,
            menus: [],
            editingMenuItemMessage: '',
            doCancelMenuItem: false,
            menuItems: [],
            filters: {
				page: 1,
				search_term: '',
				menu: {
                    client_id: '',
                    menu_id: '',
                    menu_label: '',
                    link_type: '',
                    link_value: '',
                    sub_menu_id: '',
                    sort_order: '',
                    menu_code: '',
                    description: '',
                    menu_items_available: '',
                    menu_items: []
                }
			}
        }
    },
    created() {
        // this.fetchMenus()
    },
    methods: {
        fetchMenus() {
            this.apiCall({ destination: 'get_list_menus', data: { menu_code: 'FLIGHT_DECK_MAIN', client_id: 1 } }).then(obj => {
                this.menus = obj.menus
                this.loading = false
            }).catch(err => {
                this.loading = false
                console.log(err);
            })
        },
        fetchMenu(menu) {
            this.loading = true
			// var menuCode = this.filters.menu.menu_code
			this.apiCall({ destination: 'get_item_menu', data: { menu_code: menu.menu_code }} ).then(obj => {
				this.loading = false
				this.filters.menu.menu_id = obj.menu.menu_id
				this.filters.menu.menu_items_available = obj.menu_items_available
				this.filters.menu.menu_items = obj.menu_items
			}).catch(err => {
				console.log(err)
			})
        },
        saveMenu(menu) {
            this.saving = true
			this.apiCall({ destination: 'save_item_menu', data: { menu_id: menu.menu_id, menu_code: menu.menu_code, description: menu.description, menu_items: menu.menu_items }} ).then(obj => {
				this.saving = false
				if (obj.status == 'error') {
					this.message = obj.message
				} else {
                    menu.menu_code = obj.menu_code
					this.fetchMenu(menu)
				}
			}).catch(err => {
				console.log(err)
			})
        },
        deleteMenu(menuId) {
            this.apiCall({ destination: 'delete_item_menu', data: { menu_id: menuId }} ).then(obj => {
				this.loading = false
				if (obj.status == 'error') {
					this.message = obj.message
				} else {
                    this.fetchMenus()
					//this.fetchMenu(this.filters.menu)
                    // Sort of hackish, just flip-flopping this.doCancelMenuItem to let
                    // the menu component know to fire the function cancelMenuItem
				}
			}).catch(err => {
				console.log(err)
			})
        },
        saveMenuItem(menuItem) {
            this.apiCall({ destination: 'save_item_menu_item', data: { menu_item: menuItem }} ).then(obj => {
				this.loading = false
				if (obj.status == 'error') {
					this.editingMenuItemMessage = obj.message
				} else {
					this.fetchMenu(this.filters.menu)
                    // Sort of hackish, just flip-flopping this.doCancelMenuItem to let
                    // the menu component know to fire the function cancelMenuItem
					this.doCancelMenuItem = !this.doCancelMenuItem
				}
			}).catch(err => {
				console.log(err)
			})
        }
    }
}
</script>

<style>

</style>
